import React, { useEffect, useRef, useState } from "react";
import { useAddEditEventLessonTimeSlotDetailsMutation, useLazyGetLessonTimeSlotDetailsByIdQuery } from "../../../../../app/services/EventManagement/EventManagementApi";
import SwalAlert from "../../../../../services/swalService/SwalService";
import Buttons from "../../../../../components/ui/button/Buttons";
import FormCreator from "../../../../../components/forms/FormCreator";
import { SessionEditFormData } from "../data/SessionEditForm.Data";

const SessionEditForm = ({ initState, isModelClose }) => {
    const lessionFormRef = useRef()
    const [addEventLessionMutation, { isLoading: isLoadingLession, isSuccess: isSuccessLession, data: addEventLessionResponse }] = useAddEditEventLessonTimeSlotDetailsMutation();
    const { success } = SwalAlert();
    const [formData, setFormData] = useState(SessionEditFormData);
    const eventId = initState.eventId;
    const [getLessionTimeSlotListByEventId] = useLazyGetLessonTimeSlotDetailsByIdQuery();

    useEffect(() => {
        getLessionTimeSlotListByEventId({ eventId });
    }, [eventId])

    const formReset = () => {
        const sessioninitialForm = { ...SessionEditFormData };
        sessioninitialForm.initialState = { ...SessionEditFormData.initialState };
        setFormData(sessioninitialForm);
    }

    useEffect(() => {
        if (initState) {
            setFormData((prev) => ({
                ...prev,
                initialState: {
                    ...prev.initialState,
                    sessions: initState.sessionLabel || null,
                    scheduleDate: initState.eventLessonDate || null,
                    qty: initState.availableSeats || null,
                    seatbooked: initState.bookedSeats || null,
                    startAt: initState.eventStartTime || null,
                    endAt: initState.eventEndTime || null,
                    howToGetThere: initState.howToGetThere || null,
                    address: initState.address || null,
                },
            }));
        }
    }, [initState]);

    useEffect(() => {
        if (!isLoadingLession && isSuccessLession && addEventLessionResponse) {
            success("Sessions have been updated successfully !");
        }
    }, [isLoadingLession, isSuccessLession, addEventLessionResponse]);

    const backToList = () => {
        isModelClose();
        getLessionTimeSlotListByEventId({ eventId });
        formReset();
    }

    const handleSave = () => {
        // success("Sessions have been updated successfully !");
        const formData = lessionFormRef.current.getFormData();
        const request = {
            sessions: formData.sessions || null,
            TimeSlotDate: formData.scheduleDate || null,
            AvailableSeats: formData.qty || null,
            seatbooked: formData.seatbooked || null,
            EventStartTime: formData.startAt || null,
            EventEndTime: formData.endAt || null,
            howToGetThere: formData.howToGetThere || null,
            GoogleMapPath: formData.address || null,
            EventTimeSlotId: initState.eventTimeSlotId,
            EventId: initState.eventId,
            EventLessonId: initState.eventLessonId
        }
        addEventLessionMutation(request)
        backToList();
    }

    return (
        <div>
            {/* <p>{JSON?.stringify(formData?.initialState)}</p> */}
            <FormCreator
                config={formData}
                ref={lessionFormRef}
                key={false}
            />
            <Buttons
                buttonText="Save"
                buttonTypeClassName="theme-btn btn mt-auto"
                onClick={handleSave}
            />
        </div>
    );
};

export default SessionEditForm;
